// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function MM_cmp_editor_select_theorems(props) {
  var onCancel = props.onCancel;
  var onOk = props.onOk;
  var labels = props.labels;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        
      });
  var setSelectedLabels = match[1];
  var selectedLabels = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var setFilter = match$1[1];
  var filter = match$1[0];
  var actSetFilter = function (newFilter) {
    setFilter(function (param) {
          return newFilter.toLowerCase();
        });
  };
  var actOk = async function () {
    var $$continue = await MM_react_common.openOkCancelDialog(modalRef, "Confirm inlining theorems", undefined, undefined, labels.filter(function (label) {
                return Belt_SetString.has(selectedLabels, label);
              }).join(", "), undefined, undefined);
    if ($$continue) {
      return onOk(Belt_SetString.toArray(selectedLabels));
    }
    
  };
  var rndFilter = function () {
    return React.createElement(TextField, {
                value: filter,
                label: "Label",
                size: "small",
                style: {
                  width: "200px"
                },
                onChange: Expln_React_common.evt2str(actSetFilter),
                onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEsc, undefined, undefined, undefined, onCancel),
                autoFocus: true
              });
  };
  var rndCheckboxes = function () {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(labels.filter(function (label) {
                            return label.toLowerCase().includes(filter);
                          }).map(function (label) {
                          return JsxPPXReactSupportU.createElementWithKey(label, FormControlLabel, {
                                      control: React.createElement(Checkbox, {
                                            checked: Belt_SetString.has(selectedLabels, label),
                                            onChange: (function (param) {
                                                setSelectedLabels(function (selectedLabels) {
                                                      if (Belt_SetString.has(selectedLabels, label)) {
                                                        return Belt_SetString.remove(selectedLabels, label);
                                                      } else {
                                                        return Belt_SetString.add(selectedLabels, label);
                                                      }
                                                    });
                                              })
                                          }),
                                      label: label
                                    });
                        }))
              });
  };
  return React.createElement(Expln_React_Column.make, {
              children: Caml_option.some(null)
            }, React.createElement("span", {
                  style: {
                    fontSize: "1.1em",
                    fontWeight: "bold"
                  }
                }, "Select theorems to inline:"), rndFilter(), rndCheckboxes(), React.createElement(Expln_React_Row.make, {
                  children: Caml_option.some(null)
                }, React.createElement(Button, {
                      onClick: (function (param) {
                          actOk();
                        }),
                      variant: "contained",
                      disabled: Belt_SetString.size(selectedLabels) === 0,
                      children: "Ok"
                    }), React.createElement(Button, {
                      onClick: (function (param) {
                          onCancel();
                        }),
                      children: "Cancel"
                    })));
}

var make = MM_cmp_editor_select_theorems;

exports.make = make;
/* react Not a pure module */
